import { IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { IFormBuilder } from '../IFormBuilder';
import { FormControl } from '@angular/forms';
import { AddressControls, AddressOption } from './AddressFormBuilder';
import { BillAddressFormGroup } from '../BillAddressFormGroup';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { BaryAddressService } from '../../../services/bary-address.service';

interface IBillAddressFormBuilder extends IFormBuilder<BillAddressControls> {
  init(): IBillAddressFormBuilder;

  build(): IGenericBaryFormGroup<BillAddressControls>;
}

export type BillAddressControls = AddressControls & {
  billEmail: FormControl;
};

export type BillAddressOption = AddressOption & {
  billEmail?: string;
};

export class BillAddressFormBuilder implements IBillAddressFormBuilder {
  private formName = 'billAddressForm';
  private controls!: BillAddressControls;
  private addressType = { pickup: false, delivery: false, address: false };

  constructor(private bcf: BaryFormFactoryService, protected baryAddressUtil: BaryAddressService) {}

  init(option?: BillAddressOption): BillAddressFormBuilder {
    this.addressType.address = true;
    return this.innerInit(option);
  }

  private innerInit(option?: BillAddressOption): BillAddressFormBuilder {
    this.controls = this.bcf.makeBillAddressWithOptionControls(option);
    return this;
  }

  build(): BillAddressFormGroup {
    return new BillAddressFormGroup(this.formName, this.addressType, this.controls, this.baryAddressUtil);
  }
}
